import { Row, Col, Card, Descriptions, Timeline, Button } from "antd";
import { useEffect, useState } from "react";
import {
  ArrowLeftOutlined,
  SmileOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { getDeviceLogs } from "../api/devices";
import { useNavigate } from "react-router-dom";
import moment from "moment";

function DeviceLogs() {
  const navigate = useNavigate();
  const [deviceID, setDeviceID] = useState(
    window.history.state?.usr?.device_id
  );
  const [deviceLogs, setDeviceLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (deviceID) {
      _getDeviceLogs(deviceID);
    }
  }, [deviceID]);

  const _getDeviceLogs = async (id) => {
    setLoading(true); // Show loading state
    try {
      const res = await getDeviceLogs(id);
      if (res?.statusCode === 200) {
        setDeviceLogs(res?.data);
      } else {
        console.error("Failed to fetch device logs");
      }
    } catch (e) {
      console.error("Error fetching device logs", e);
    }
    setLoading(false); // Hide loading state
  };

  const _goBack = () => {
    navigate(-1);
  };

  return (
    <div className="tabled">
      <div
        style={{ paddingTop: 10, paddingBottom: 10, cursor: "pointer" }}
        onClick={_goBack}
      >
        <ArrowLeftOutlined /> Back
      </div>

      <Row gutter={[24, 0]}>
        <Col xs={24} xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title={deviceLogs?.name || "Device Logs"}
            extra={
              <Button
                icon={<ReloadOutlined />}
                onClick={() => _getDeviceLogs(deviceID)}
                loading={loading}
              >
                Refresh Logs
              </Button>
            }
          >
            <div className="ant-list-box m-25 px-2">
              <Descriptions bordered>
                <Descriptions.Item label="ID">{deviceID}</Descriptions.Item>
                <Descriptions.Item label="Name">
                  {deviceLogs?.name || "N/A"}
                </Descriptions.Item>
                {/* You can add more details here from the deviceLogs */}
              </Descriptions>
            </div>
            <div className="px-2 m-25">
              <Timeline>
                {deviceLogs.slice(0, 40).map((log, index) => (
                  <Timeline.Item
                    key={index}
                    color={
                      log.device_state === "cooking"
                        ? "red"
                        : log.device_state === "cooling"
                        ? "blue"
                        : "gray"
                    }
                  >
                    <p>
                      <strong>Device State:</strong> {log.device_state}
                    </p>
                    <p>
                      <strong>Water State:</strong> {log.water_state}
                    </p>
                    <p>
                      <strong>Update Source:</strong> {log.update_source}
                    </p>
                    <p>
                      <strong>Updated At:</strong>{" "}
                      {moment(log.updatedAt).format("YYYY-MM-DD HH:mm:ss")}
                    </p>
                  </Timeline.Item>
                ))}
                <Timeline.Item color="black" dot={<SmileOutlined />}>
                  {deviceLogs?.length === 0 ? (
                    <p>No Logs Found</p>
                  ) : (
                    <p>End of Logs</p>
                  )}
                </Timeline.Item>
              </Timeline>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default DeviceLogs;
